import angular from 'angular'

angular
  .module('admin.product_subcategories.service', [])
  .factory('ProductSubCategoriesService', ProductSubCategoriesService)

/** @ngInject */
function ProductSubCategoriesService($http, $q, API) {
  function list(parentId, start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL +
          'admin/product_categories/' +
          parentId +
          '/product_subcategories?start=' +
          start +
          '&limit=' +
          limit +
          '&sort=id-asc',
      )
      .success(defered.resolve)

    return defered.promise
  }

  function get(id) {
    var defered = $q.defer()

    $http.get(API.API_URL + 'admin/product_subcategories/' + id).success(defered.resolve)

    return defered.promise
  }

  function save(model) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + 'admin/product_subcategories', model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function update(id, model) {
    var defered = $q.defer()

    $http
      .put(API.API_URL + 'admin/product_subcategories/' + id, model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function remove(id) {
    var defered = $q.defer()

    $http
      .delete(API.API_URL + 'admin/product_subcategories/' + id)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  return {
    list: list,
    get: get,
    save: save,
    update: update,
    remove: remove,
  }
}
